<template>
  <atoms-card
    rounded="md"
    :shadow="theme === 'default' ? 'bordered' : 'none'"
    :size="theme === 'v2' ? 'lg' : 'standard'"
    :class="{
      'text-center md:max-w-2.5xl mx-auto': theme !== 'v2',
      'border lg:border-gray-400 bg-blue-5 -mx-4 lg:mx-auto rounded-none lg:rounded-2.5xl pb-8': theme === 'v2'
    }"
  >
    <p
      class="font-bold"
      :class="{
        'text-2xl mt-3': theme === 'default',
        'text-xl lg:text-2xl': theme === 'v2'
      }"
    >
      {{ title }}
    </p>

    <!-- eslint-disable vue/no-v-html -->
    <div
      :class="{
        'text-small lg:text-regular mt-2': theme === 'v2'
      }"
      v-html="subtitle"
    >
    </div>

    <div
      v-if="theme === 'default'"
      class="mt-6 md:w-3/4 mx-auto mb-6"
    >
      <atoms-cta
        v-for="(option, index) in options"
        :id="`'cta-inline-lifestage-${option.image}}`"
        :key="index"
        :to="option.link"
        size="large"
        class="flex items-center mb-4 font-normal hover:font-bold"
      >
        <AtomsImage
          width="36"
          height="23"
          class="mr-2"
          :alt="`cta ${option.image}`"
          :src="`/images/lifestage/${option.image ? option.image : 'single'}.png`"
          :image-lazy-load="imageLazyLoad"
        />

        <span class="text-white">
          {{ option.label }}
        </span>
      </atoms-cta>
    </div>

    <div
      v-else-if="theme === 'v2'"
      class="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-4"
    >
      <atoms-button
        v-for="(option, index) in options"
        :id="`'cta-inline-lifestage-${option.image}}`"
        :key="index"
        class="text-center"
        :to="option.link"
        theme="secondaryWithImage"
        size="extra small"
      >
        <AtomsImage
          width="56"
          height="56"
          :alt="`cta ${option.image}`"
          :src="`/images/lifestage/lifestage-${option.image ? option.image : 'single'}.svg`"
          :image-lazy-load="imageLazyLoad"
        />

        <span class="text-sm block text-center font-bold mt-2">
          {{ option.label }}
        </span>
      </atoms-button>
    </div>
  </atoms-card>
</template>

<script setup>
defineOptions({
  name: 'MoleculesInlineLifeStage'
})

const props = defineProps({
  ctaId: {
    type: String,
    default: 'inline-card-cta'
  },
  ctaClass: {
    type: String,
    default: ''
  },
  componentVertical: {
    type: String,
    default: 'Home Loans'
  },
  customComponent: {
    type: Object,
    default: () => ({})
  },
  title: {
    type: String,
    default: 'Select your state and compare now!'
  },
  subtitle: {
    type: String,
    default: 'Discover the best options for you'
  },
  redirectUrl: {
    type: String,
    default: '/home-loans/quote/form/step1/'
  },
  ctaType: {
    type: String,
    default: 'State'
  },
  theme: {
    type: String,
    default: 'default',
    validator: value => ['default', 'v2'].includes(value)
  },
  imageLazyLoad: {
    type: Boolean,
    default: false
  }
})

const options = [
  {
    label: 'Just me',
    image: 'single',
    link: props.redirectUrl + '?life_stage=Single'
  },
  {
    label: 'Me and my partner',
    image: 'couple',
    link: props.redirectUrl + '?life_stage=Couple'
  },
  {
    label: 'My family',
    image: 'family',
    link: props.redirectUrl + '?life_stage=Family'
  },
  {
    label: 'Me and my kid(s)',
    image: 'single-parent',
    link: props.redirectUrl + '?life_stage=Single Parent'
  }
]
</script>
